import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-companyInformation",
  "use": "icon-companyInformation-usage",
  "viewBox": "0 0 250 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 250 200\" id=\"icon-companyInformation\">\n<path class=\"st0\" d=\"M234.4,0H15.6C7,0,0,7,0,15.6v168.8C0,193,7,200,15.6,200h218.8c1.2,0,2.3-0.1,3.4-0.4c2,0,3.9-0.7,5.3-2v-0.5\n\tc4.2-2.9,6.8-7.6,6.9-12.7V15.6C250,7,243,0,234.4,0z M125,114.1L17.6,17.6H233L125,114.1z M15.6,36.8l72,64.8l-72,71.8V36.8z\n\t M99.3,111.7l20.8,18.7c3,2.6,7.4,2.6,10.4,0l22.1-19.8l67.7,73.8H26.6L99.3,111.7z M164.1,100.2l70.3-62.5v139.1L164.1,100.2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/companyInformation.svg
// module id = s+P7
// module chunks = 183